/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const YouTube = ({ color = 'silver', height = 32, ...props }) => {
  return (
    <svg
      width={32}
      height={height}
      viewBox="0 0 32 32"
      sx={{ fill: color }}
      {...props}
    >
      <g clipPath="url(#clip0)" fill="#DBD6D1">
        <path d="M14.007 18.998L19.212 16l-5.205-2.997v5.995z" />
        <path d="M16 0C7.165 0 0 7.165 0 16s7.165 16 16 16 16-7.165 16-16S24.835 0 16 0zm9.998 16.017s0 3.244-.412 4.809a2.505 2.505 0 01-1.762 1.762C22.258 23 16 23 16 23s-6.242 0-7.823-.428a2.506 2.506 0 01-1.763-1.763C6.002 19.261 6.002 16 6.002 16s0-3.245.412-4.81a2.556 2.556 0 011.763-1.778C9.74 9 16 9 16 9s6.259 0 7.823.428c.857.23 1.532.906 1.763 1.763.428 1.564.412 4.825.412 4.825z" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0H32V32H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

YouTube.propTypes = {
  color: string,
  height: number,
}

export default YouTube
